import { MouseEventHandler, ReactNode } from 'react';
import classNames from 'classnames';

import { OptionStatus } from 'types/ProductOptionGroup';

import classes from './SelectorOption.module.scss';

const statusClassesMap: { [key in OptionStatus]: string } = {
  active: classes.statusActive,
  soon: classes.statusSoon,
  inactive: classes.statusInactive,
};

type Props = {
  className?: string;
  isSelected: boolean;
  isPredictionActive?: boolean;
  isFadedOut?: boolean;
  status?: OptionStatus;
  children: ReactNode;
  onHoverIn?: () => void;
  onHoverOut?: () => void;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const SelectorOption = ({
  className,
  isSelected,
  isPredictionActive,
  isFadedOut,
  status = 'soon',
  children,
  onHoverIn,
  onHoverOut,
  onClick,
}: Props) => {
  const isOptionClickable = ['active', 'soon'].includes(status);

  return (
    <button
      type="button"
      className={classNames(classes.wrapper, statusClassesMap[status], className, {
        [classes.isSelected]: isSelected && !isFadedOut && !isPredictionActive,
        [classes.isPredictionActive]: isPredictionActive,
        [classes.isFadedOut]: isFadedOut && !isPredictionActive,
      })}
      {...(isOptionClickable ? { onClick, onMouseEnter: onHoverIn, onMouseLeave: onHoverOut } : {})}
    >
      {children}
    </button>
  );
};

export default SelectorOption;
